<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg {{$t('mantraDesc')}}

  section.u-mt-md
    .grid.is-tablet-6.is-widescreen-4
      .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
        h4 {{item.title}}
        p {{item.desc}}



  .u-mb-md

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Together",
    "pageDesc":"Together is an initiative by Baianat through which we aim to create better living conditions for humans around the world.",
    "mantra":"Technology for |good.",
    "mantraDesc":"We believe that technology has a role to play in nations renaissance. Through together, we are trying to eradicate the different forms of injustice and provide better living conditions for humans.",
    "sec1Items":{
      "1":{
        "title":"A rich life for minorities.",
        "desc":"By supporting the goals of zero hunger and no poverty, we are trying to maximize the human potential in the world and provide the basic needs for those who are suffering from malnutrition."
      },
      "2":{
        "title":"Good health and well-being ",
        "desc":"Good health should be promoted in every community regardless of social class or status. By spreading awareness through campaigns and strategic partnerships, we hope to make a change needed in human habits."
      }
    }
  },
  "ar": {
    "pageTitle":"معًا",
    "pageDesc":"معًا هي مبادرة من قبل بيانات التي تهدف من خلالها إلى خلق ظروف معيشية أفضل للبشر في جميع أنحاء العالم.",
    "mantra":"تسخير التكنولوجيا |للأعمال الخيرية.",
    "mantraDesc":"نؤمن أن التكنولوجيا تلعب دور مهم في نهضة الأمم. من خلال مبادرة معًا نحاول القضاء على أشكال الظلم المختلفة وتوفير ظروف معيشية أفضل للجميع.",
    "sec1Items":{
      "1":{
        "title":"حياة أفضل للأقليات",
        "desc":"ندعم جميع الأهداف التي تدعو إلى التخلص من الفقر والجوع. نحاول تعظيم الإمكانات البشرية في العالم وتوفير الاحتياجات الأساسية من أجل الذين يعانون من سوء التغذية."
      },
      "2":{
        "title":"الصحة الجيدة",
        "desc":"يجب العمل على تعزيز الصحة الجيدة في كل مجتمع بغض النظر عن الطبقة الاجتماعية أو الوضع الاجتماعي. من خلال نشر الوعي عبر الحملات والشراكات الاستراتيجية، نأمل في إحداث التغيير اللازم في العادات الإنسانية."
      }
    }
  }
}
</i18n>
